import { render, staticRenderFns } from "./Report-teacher.vue?vue&type=template&id=43afe406"
import script from "./Report-teacher.vue?vue&type=script&lang=js"
export * from "./Report-teacher.vue?vue&type=script&lang=js"
import style0 from "./Report-teacher.vue?vue&type=style&index=0&id=43afe406&prod&lang=scss"
import style1 from "./Report-teacher.vue?vue&type=style&index=1&id=43afe406&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports